module.exports = __webpack_public_path__ + "static/menu-ikeda-sengyo-min3-e3e409499772b805550081517611c2ed.jpg";